import { DashboardRouter } from '../components/DashboardRouter';

export function DashboardPage() {
  return <DashboardRouter />;
}
